module.exports = "<p style=\"margin: 10px\">\n  Dashboard coming soon!\n</p>\n"